import { Route } from 'vue-router';
import { Next } from '@cnamts/vue-dot/src/types';

import { MAINTENANCE_ENABLED } from '@/constants';

export function navigationRedirectGuard(to: Route, from: Route, next: Next): void {
	if (MAINTENANCE_ENABLED) {
		if ('maintenance' !== to.name) {
			next({ name: 'maintenance' });
		} else {
			next();
		}
	} else if ('maintenance' === to.name) {
		next({ name: 'home' });
	}
	next();
}
